<template>
	<inertia-head title="BCC" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h3 class="fw-bold text-white mb-2">
						{{
							`Welcome to the ${$page.props.app.name} - Blockchain Circle (BCC)`
						}}
					</h3>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Blockchain Circle Dashboard
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="alert alert-success alert-dismissible shadow" role="alert">
			<button
				type="button"
				class="btn-close"
				data-bs-dismiss="alert"
				aria-label="Close"
			></button>
			<h3 class="alert-heading fs-5 fw-bold mb-1">Congratulations!</h3>
			<p class="mb-0">
				You are now an official member of the Blockchain Circle! We are excited
				to be with you on your Blockchain journey. Exciting things are up in
				store for you but first, click the button below and get your access to
				our exclusive
				<a class="alert-link" href="javascript:void(0)">Discord Goup</a>!
			</p>
		</div>
		<div class="block block-rounded mt-5">
			<div class="block-content block-content-full">
				<div class="row">
					<div class="col-xl-3 col-md-4 col-sm-3 text-center">
						<img src="/media/logo/discord-logo.png" class="img-fluid" alt="" />
					</div>
					<div class="col text-center">
						<h4 class="fw-bold">
							This is your first step to your Blockchain journey!
						</h4>
						<p>
							Discord is going to be our main channel when it comes to
							communicating with each other. Once inside please message our
							Community Mod the email address you used to signup for Blockchain
							Circle so they can assign you your Discord access.
						</p>
						<a
							href="https://discord.com/invite/x4B9vWATBc"
							class="btn btn-alt-primary btn-lg py-3 text-uppercase shadow"
							target="_blank"
							data-bs-toggle="tooltip"
							data-bs-placement="bottom"
							title="Join to discord server by clicking this button"
						>
							Click here to join the discord server
						</a>
						<p class="mt-3 fs-sm">
							Please do not share this link. This is your exclusive link.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue';
import AuthLayout from '../../../Layouts/AuthLayout';

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	props: {
		user: Object,
		bcc: Object,
		trc: Object,
	},
	setup() {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})
	},
}
</script>
